var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"worksheet-form"},[_c('sidebar',{staticClass:"worksheet-form__sidebar"}),_c('vue-scroll',{key:"scroll"},[_c('drop-area',[_c('drag-area')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }